export const QueryKey = {
    projectVipInfo: 'projectVipInfo',
    projectVipLevelList: 'projectVipLevelList',
}
